import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, Chapter } from './StartShared';

export const TreatmentStack = ({ copy }) => (
  <section id="behandlungen" className="start-treatments start-light" aria-labelledby="treatments-heading" data-testid="start-treatments">
    <div className="start-container">
      <Chapter number="01" label={copy.treatments.label} id="treatments-heading" />
      <Reveal className="start-section-intro">
        <p className="start-display" data-testid="start-treatments-title">{copy.treatments.title[0]}<br /><span className="start-muted">{copy.treatments.title[1]}</span></p>
        <p className="start-intro-text" data-testid="start-treatments-description">{copy.treatments.intro}</p>
      </Reveal>
      <div className="start-treatment-grid">
        {copy.treatments.items.map((item, index) => (
          <Reveal key={item.id} delay={index * 0.07}>
            <Link to={item.href} className="start-treatment" data-testid={`treatment-card-${item.id}`}>
              <div className="start-treatment-image">
                <img src={`/images/start/${item.image}.webp`} alt={item.alt} loading="lazy" width="805" height="1200" data-testid={`treatment-image-${item.id}`} />
                <span className="start-treatment-number start-mono" aria-hidden="true">0{index + 1}</span>
                <span className="start-treatment-arrow"><ArrowUpRight size={23} aria-hidden="true" /></span>
              </div>
              <div className="start-treatment-copy" data-testid={`treatment-copy-${item.id}`}>
                <h3>{item.name}</h3>
                <p className="start-treatment-full start-mono">{item.full}</p>
                <p className="start-treatment-description">{item.description}</p>
                <span className="start-treatment-link">{copy.treatments.discover}<ArrowUpRight size={16} aria-hidden="true" /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
      <p className="start-image-note start-mono" data-testid="start-portrait-disclaimer">{copy.treatments.note}</p>
    </div>
  </section>
);